module.exports = __webpack_public_path__ + "static/media/ST11.d4166f4d.mp3";